// extracted by mini-css-extract-plugin
var _1 = "dsQhf";
export { _1 as "base" }
